/**
 * Renders the menu dropdown component
 */
import * as React from 'react';

import Link from 'next/link';

import {
  ComingSoonContainer,
  DropDownContainer,
  DropDownItem,
  DropDownLink,
  DropDownLinkComingSoon,
} from './styles';

/**
 * Menu dropdown item
 *
 * @param props - Render props
 */
function Item(props: DropdownItemProps) {
  const { children, url, comingSoon, migrated, onClick } = props;

  if (comingSoon) {
    return (
      <DropDownItem>
        <DropDownLinkComingSoon>{children}</DropDownLinkComingSoon>
        <ComingSoonContainer>COMING SOON</ComingSoonContainer>
      </DropDownItem>
    );
  }

  if (migrated) {
    return (
      <DropDownItem>
        <DropDownLink href={url} onClick={onClick}>
          {children}
        </DropDownLink>
      </DropDownItem>
    );
  }

  return (
    <DropDownItem>
      <Link href={url} prefetch={false}>
        <DropDownLink href={url} onClick={onClick}>
          {children}
        </DropDownLink>
      </Link>
    </DropDownItem>
  );
}
/**
 * Menu dropdown component
 *
 * @param props - Render props
 */
export function DropDown(props: DropdownMenuProps) {
  const { children } = props;

  return <DropDownContainer>{children}</DropDownContainer>;
}
DropDown.Item = Item;

/** Type definition */
interface DropdownItemProps {
  /** Item's children */
  children: React.ReactNode;
  /** Url for the internal link */
  url: string;
  /** Coming soon flag */
  comingSoon?: boolean;
  /** Migrated flag */
  migrated?: boolean;
  /** Whether or not the side menu is open */
  isSideMenuOpen?: boolean;
  /** Emits an `onClick` event */
  onClick(): void;
}

type DropdownMenuProps = { children: React.ReactNode };
